import { apiCall } from "~/lib/redux/api";
import { DepartmentActions, EntityActions } from "~/apps/shared/actions/consts";
import * as api from "~/apps/shared/apis/departments";
import { DepartmentNormalizer } from "~/apps/shared/actions/normalize";

export function getDepartmentById(id) {
  return apiCall({
    actions: [
      DepartmentActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, DepartmentActions.LOAD_SUCCESS],
      DepartmentActions.LOAD_ERROR,
    ],
    normalizer: DepartmentNormalizer,
    fn: () => api.getDepartmentById(id),
  })
}

export function getDepartments() {
  return apiCall({
    actions: [
      DepartmentActions.LOAD_REQUEST,
      [EntityActions.ADD_ENTITIES, DepartmentActions.LOAD_LIST_SUCCESS],
      DepartmentActions.LOAD_ERROR,
    ],
    normalizer: [DepartmentNormalizer],
    fn: () => api.getDepartments(),
  })
}
